import $ from 'jquery';
import {favouriteRemove} from './favourites';

const updaterRegistry = [];
export const sessionKey = 'site-data';

function isEmpty(obj) {
  if (!obj) return true
  return Object.keys(obj).length === 0 && obj.constructor === Object
}

export function registerUpdater (func) {
  /* Register an updater function which should run after fetching data. */
  updaterRegistry.push(func);
}

export function updateFavourites (favourites) {
  const html = document.documentElement

  html.classList[favourites.count ? 'add' : 'remove']('state-favourites-has-items');
  html.classList[favourites.count ? 'add' : 'remove']('state-favourites-empty');

  html.querySelector('.favourites-snippet').innerHTML = favourites.html_snippet || '';
  html.querySelector('.favourites-item-count').textContent = favourites.count || '';

  // bind the remove form
  html.querySelectorAll('.favourites-snippet form.remove-favourite:not(.initialised)').forEach((form) => {
    favouriteRemove(form);
    form.classList.add('initialised');
  });
}


export const updateCart = (cart) => {
  const html = document.documentElement

  html.classList[cart.count ? 'add' : 'remove']('state-cart-has-items');
  html.classList[cart.count ? 'remove' : 'add']('state-cart-empty');
  html.querySelector('.cart-item-count').textContent = cart.count || '';
  html.querySelector('.cart-item-plural').textContent = parseInt(cart.count, 10) !== 1 ? 's' : '';
  html.querySelector('.cart-snippet').innerHTML = cart.html_snippet || '';
}

export function globalUpdate (data) {
  // set site state based on data
  const html = document.documentElement

  html.classList[isEmpty(data.account) ? 'remove' : 'add']('state-logged-in');
  html.classList[isEmpty(data.account) ? 'remove' : 'add']('state-anon');

  if (!isEmpty(data.account)) {
    html.querySelector('.account-name').innerHTML = `${data.account.user.first_name} ${data.account.user.last_name}`
  }

  if (!isEmpty(data.favourites)) {
    updateFavourites(data.favourites);
  }

  if (!isEmpty(data.cart)) {
    updateCart(data.cart)
  }

  updaterRegistry.forEach((func) => {
    func(data);
  });
}

export function fetchData () {
  // TODO should just update based on the session data if it's there, but will
  // need to make sure it gets updated whenever globalUpdate is called - note
  // the data passed to globalUpdate may be incomplete, so the update needs to
  // be granular

  // for now, just run two updates - one on the session data and then another
  // once fresh data has been fetched

  const sessionData = JSON.parse(window.sessionStorage.getItem(sessionKey));

  function doUpdate (data) {
    globalUpdate(data);
    $('html').addClass('state-data-loaded');
  }

  if (sessionData) {
    doUpdate(sessionData);
  }
  $.get(window.URLS.get_data, function (data) {
    window.sessionStorage.setItem(sessionKey, JSON.stringify(data));
    doUpdate(data);
  });
}



// WEBPACK FOOTER //
// ./assets/j/shoptools/index.js